import React from "react";
import "./OfferingSection.css";
import { FaDraftingCompass, FaBrain, FaCogs, FaUsers, FaChartLine } from "react-icons/fa";

const features = [
  {
    icon: <FaDraftingCompass />,
    title: "Architecture First",
    desc: "We start with the end in mind and design the right architecture for sustained business outcomes.",
  },
  {
    icon: <FaBrain />,
    title: "AI with Purpose",
    desc: "We apply AI where it creates real advantage, not noise—for measurable impact at scale.",
  },
  {
    icon: <FaCogs />,
    title: "Execution Excellence",
    desc: "We don’t just design change, We deliver it—with relentless focus on outcomes.",
  },
  {
    icon: <FaUsers />,
    title: "Human-Centered Change",
    desc: "We activate people, culture and leadership to adapt and scale with resilience.",
  },
  {
    icon: <FaChartLine />,
    title: "Outcomes That Compound",
    desc: "We build capabilities and momentum that deliver compounding long-term value.",
  },
];

function OfferingSection() {
  return (
    <section className="offering">
      <div className="offering-container">
        <div className="offering-left">
          <p className="label">THE BAIREES OFFERING</p>
          <h2>
            We don’t advise,
            <br />
            We <span>architect</span> transformation 
            <br />
            that endures.
          </h2>
          <p className="subtext">
            Most transformations fail not because of technology, but because of
            misaligned design, fragmented execution, and weak delivery.
            <br /><br />
           <span> We bring coherence to complexity.</span>
          </p>
        </div>

        <div className="offering-right">
          {features.map((item, i) => (
            <div className="feature" key={i}>
              <div className="icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OfferingSection;